export const TitleSuffix = 'Environment Administration';
